import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTelegram(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M4.62757 14.5015C12.5273 11.0262 22.7502 6.7891 24.1614 6.20265C27.863 4.66771 28.9988 4.96187 28.4324 8.36113C28.0258 10.8043 26.8522 18.8933 25.9169 23.9281C25.3619 26.9137 24.1167 27.2676 22.1588 25.9759C21.2172 25.3543 16.4646 22.2115 15.4332 21.4735C14.4916 20.801 13.193 19.992 14.8216 18.3986C15.4011 17.831 19.2001 14.2036 22.16 11.3801C22.5478 11.0093 22.0607 10.4002 21.6132 10.6975C17.6237 13.3431 12.0924 17.0152 11.3884 17.4935C10.3248 18.2157 9.30344 18.547 7.46993 18.0202C6.08458 17.6223 4.73128 17.1478 4.20455 16.9668C2.17618 16.2703 2.65766 15.3683 4.62757 14.5015Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTelegram);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
